import React, { FC } from 'react';
import NextImage from 'src/shared-components/NextImage/NextImage';

interface Props {
  averageRate: number;
}

const yellowStar = 'drug/star_rate_yellow.svg';
const halfYellowStar = 'drug/star_rate_half_yellow.svg';
const grayStar = 'drug/star_rate_gray.svg';

const Reviews: FC<Props> = ({ averageRate }) => {
  const starStatus = ['star1', 'star2', 'star3', 'star4', 'star5'].map(
    (_item, index) => {
      const isHalfStar = averageRate % 1 && index === averageRate - 0.5;
      if (
        !isHalfStar &&
        (averageRate === 0 ||
          (averageRate % 1 && index > averageRate - 1) ||
          index > averageRate - 1)
      ) {
        return grayStar;
      }
      if (
        (averageRate % 1 && index < averageRate - 1) ||
        index <= averageRate - 1
      ) {
        return yellowStar;
      }
      if (isHalfStar) {
        return halfYellowStar;
      }
      return null;
    }
  );

  return (
    <div className="flex align-center mr-[12px]">
      {starStatus.map((starImage, index) => {
        return (
          <div key={index}>
            <NextImage
              alt="star"
              src={starImage}
              layout="fixed"
              height={18}
              width={18}
              priority
            />
          </div>
        );
      })}
    </div>
  );
};

export default Reviews;
